import { ENTITY_ID_HEADER, ROOT_USER_ID_HEADER } from '@/services/api.service'

export function entityHeaders(
  entityId: string,
  rootUserId: string
): Record<string, string> {
  return {
    [ENTITY_ID_HEADER]: entityId,
    [ROOT_USER_ID_HEADER]: rootUserId,
  }
}
